<template>

  <div class="text-center social_share_container">
    <div class="flex_item share_text">
      Share <font-awesome-icon :icon="{prefix: 'fas', iconName: 'caret-right'}"></font-awesome-icon>
    </div>
    <div class="flex_item">
      <div class="fb_share_button"
      @click="share_fb"
      >
        <font-awesome-icon :icon="{prefix: 'fab', iconName: 'facebook-square'}"></font-awesome-icon>
      </div>
    </div>
    <div class="flex_item">
      <div class="tw_share_button"
      @click="share_tw"
      >
        <font-awesome-icon :icon="{prefix: 'fab', iconName: 'twitter-square'}"></font-awesome-icon>
      </div>
    </div>
    <div class="flex_item"
    @click="share_email"
    >
      <div class="email_share_button">
        <font-awesome-icon :icon="{prefix: 'fas', iconName: 'envelope-square'}"></font-awesome-icon>
      </div>
    </div>
  </div>

</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faEnvelopeSquare
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookSquare,
  faTwitterSquare
} from '@fortawesome/free-brands-svg-icons';
library.add(
  faFacebookSquare,
  faTwitterSquare,
  faEnvelopeSquare
);

export default {
  name: 'social_share_row',
  props: [
    'share_type',
    'contest'
  ],
  data () {
    return {
      window_url: window.location.href,
      fb_app_id: '497104900789770',
    }
  },
  methods: {
    share_fb: function() {
      // let share_url = 'https://www.facebook.com/dialog/share?app_id='+this.fb_app_id+'&display=popup&href='+escape(window.location.href)+'&redirect_uri='+escape('https://projects.dayton.com/best_of_dayton/');
      let share_url = 'https://www.facebook.com/sharer/sharer.php?u='+escape(window.location.href)+'&t='+document.title;

      window.open(share_url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Facebook Share');
    },
    share_tw: function() {
      let share_text = escape('Submit your '+this.share_type+' for "'+this.contest.label+'" for Dayton.com\'s 2018 Best of Dayton contest.');

      window.open("https://twitter.com/share?url="+escape(window.location.href)+"&text="+share_text, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Twitter Share');
    },
    share_email: function() {
      let subject = "Best of Dayton: "+this.$options.filters.capitalize_first_letter(this.share_type)+" for "+this.contest.label;
      let body = window.location.href;

      window.open('mailto:?subject='+subject+'&body='+body, '_top', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');

      this.fire_ga_event('Email Share');
    },
    fire_ga_event(event_action) {
      let vm = this; 
      
      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Sharing',
        eventAction: event_action,
        eventLabel: this.window_url
      })
    }
  },
  filters: {
    capitalize_first_letter: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.social_share_container {
  font-size: 2.5em;
  display: flex;
  justify-content: space-around;
  /*background: $dcom-orange;*/
  border-top: solid 4px #FBA88C;
  margin-bottom: 0rem;

  .flex_item {
    /*color: #FFF;*/
    color: #666;
    align-self: center;
  }

  .share_text {
    font-size: 0.6em;
    text-transform: uppercase;

    .fa-caret-right {
      margin-left: 0.5em;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/social/social_share_row.vue